import {
  Chart,
} from 'chart.js';

export function changeFontSizeForEntirePage(fontSize: number) {
  document.documentElement.style.setProperty('font-size', `${fontSize}px`);
  Chart.defaults.font.size = fontSize;
}
